<section #containerResume id="container-resume" class="section resume">
  <app-resume-shell
    [tabs]="tabs"
    [activeIndex]="activeIndex"
    [tabContent]="tabContent"
    scrollPrefix="resume"
    (tabChange)="setActive($event)"
  ></app-resume-shell>

  <app-footer
    (toggleImprint)="toggleImprint.emit()"
    (togglePrivacy)="togglePrivacy.emit()"
  ></app-footer>
</section>

<section #darkContainerResume id="dark-container-resume" class="section resume">
  <app-resume-shell
    [tabs]="tabs"
    [activeIndex]="activeIndex"
    [tabContent]="tabContent"
    scrollPrefix="resume"
    (tabChange)="setActive($event)"
  ></app-resume-shell>

  <app-footer
    (toggleImprint)="toggleImprint.emit()"
    (togglePrivacy)="togglePrivacy.emit()"
  ></app-footer>
</section>
